import { render, staticRenderFns } from "./Mright.vue?vue&type=template&id=27e14d8b&"
import script from "./Mright.vue?vue&type=script&lang=js&"
export * from "./Mright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports